import { render, staticRenderFns } from "./HomeSignupBlock.vue?vue&type=template&id=646dc7e1&scoped=true&"
import script from "./HomeSignupBlock.vue?vue&type=script&lang=js&"
export * from "./HomeSignupBlock.vue?vue&type=script&lang=js&"
import style0 from "./HomeSignupBlock.vue?vue&type=style&index=0&id=646dc7e1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646dc7e1",
  null
  
)

export default component.exports